import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  playerCard: {
    borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.divider}`,
  },

  root: {
    height: '100%',
    overflow: 'scroll',
  },
}));
